import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import {
  IonButton,
  IonCol,
  IonGrid,
  IonIcon,
  IonItemDivider,
  IonItemGroup,
  IonRow,
  IonText,
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { DecaStopType, IDecaDocumentSegment } from '@okcargo-apps/shared-domain';
import { DateFnsModule } from 'ngx-date-fns';

@Component({
  selector: 'lib-deca-detail-segment',
  templateUrl: './deca-detail-segment.component.html',
  styleUrls: ['./deca-detail-segment.component.scss'],
  imports: [
    IonItemGroup,
    IonItemDivider,
    IonIcon,
    IonGrid,
    IonRow,
    IonCol,
    IonButton,
    IonText,
    DateFnsModule,
    TranslateModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DecaDetailSegmentComponent {
  public segment = input.required<IDecaDocumentSegment>();
  public index = input.required<number>();
  public totalSegments = input.required<number>();
  public canModifyGoodsData = input<boolean>(false);
  public canModifyLocations = input<boolean>(false);
  public canModifyDates = input<boolean>(false);
  public isShipper = input<boolean>(false);
  public isCarrier = input<boolean>(false);
  public isCreator = input<boolean>(false);
  public isPastDocument = input<boolean>(false);
  /** True when the edit actions cannot be performed (no connectivity). */
  public actionsDisabled = input<boolean>(false);

  public readonly editGoods = output<void>();
  public readonly editWeight = output<void>();
  public readonly editDate = output<DecaStopType>();
  public readonly editAddress = output<DecaStopType>();
}
